
$(function () {
    $.getRecaptchaSiteKey = function() {
        const siteKey = $('body').data('recaptcha-site-key') || '';
        return siteKey;
    }
});